import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import { DomainContext } from "../../../domain-repository/DomainRepository";

import { useKeyValues } from "../../../components/SelectLanguage";
import Loading from "../../../components/Loading";
import AlertModalManager from "../../../components/alert-modal-wraper/alert-modal-manager";

import { ConventionValidateStation } from "./ConventionStation";
import { ConventionVehicleReview } from "./ConventionVehicleReview";
import { ConventionTelematica } from "./ConventionTelematica";
import { getConventionDetails } from "../keylessService";
import { VideoView } from "../components/VideoView";

export const CONVENTION_STEPS = {
  VALIDATE_STATION: "VALIDATE_STATION",
  VEHICLE_REVIEW: "VEHICLE_REVIEW",
  OPEN_CLOSE_DOORS: "OPEN_CLOSE_DOORS",
  DONE: "DONE",
};

export const CONVENTION_TOKEN = "dgf87fdgf8A2025";

export function ConventionPage() {
  const { t } = useTranslation();

  const { localizationAssets } = useContext(DomainContext);

  const { isLoading: isLoadingTranslations, handleChangeLanguage } =
    useKeyValues();

  const [currentStep, innerSetCurrentStep] = useState(null);
  const [vehicleDetails, setVehicleDetails] = useState(null);

  const setCurrentStep = useCallback((step) => {
    innerSetCurrentStep(step);
  }, []);

  useEffect(() => {
    preloadVideos([
      localizationAssets["keylessInit"],
      localizationAssets["keylessEnd"],
    ]);
    preloadImgs([
      localizationAssets["keylessGuerinLogo"],
      localizationAssets["keylessStationImage"],
      localizationAssets["keylessEnd"],
      localizationAssets["keylessFuelIcon"],
      localizationAssets["keylessTransmissionIcon"],
      localizationAssets["keylessColourIcon"],
      localizationAssets["keylessReservationHelp"],
      localizationAssets["keylessVehicleDoorsImage"],
      localizationAssets["keylessVehicleKeysImage"],
    ]);

    getConventionDetails(CONVENTION_TOKEN).then((res) => {
      setVehicleDetails(res);
      preloadImgs([res.vehicleImage]);
      handleChangeLanguage("pt");
      innerSetCurrentStep(CONVENTION_STEPS.VALIDATE_STATION);
    });
  }, []);

  if (
    currentStep === null ||
    isLoadingTranslations ||
    vehicleDetails === null
  ) {
    return <Loading active={true} />;
  }

  if (currentStep === CONVENTION_STEPS.VALIDATE_STATION) {
    return (
      <ConventionPageStyles>
        <ConventionValidateStation handleNextStep={setCurrentStep} />
      </ConventionPageStyles>
    );
  }

  if (currentStep === CONVENTION_STEPS.VEHICLE_REVIEW) {
    return (
      <ConventionPageStyles>
        <ConventionVehicleReview
          handleNextStep={setCurrentStep}
          vehicleDetails={vehicleDetails}
        />
      </ConventionPageStyles>
    );
  }

  if (currentStep === CONVENTION_STEPS.OPEN_CLOSE_DOORS) {
    return (
      <ConventionPageStyles>
        <ConventionTelematica
          handleNextStep={setCurrentStep}
          vehicleDetails={vehicleDetails}
        />
      </ConventionPageStyles>
    );
  }

  if (currentStep === CONVENTION_STEPS.DONE) {
    return (
      <ConventionPageStyles>
        <KeylessEndPage />
      </ConventionPageStyles>
    );
  }

  return (
    <div>
      <h1>Step {currentStep} em falta</h1>
    </div>
  );
}

function KeylessView({ children, history }) {
  return (
    <main>
      <div className="container">
        <div className="row">
          <div className="col-3">
            <div onClick={() => history.push("/start")}>
              <img
                src={require(`../../../assets/images/logo.png`)}
                alt="Guerin"
                className="img-fluid pt-3 pb-3"
              />
            </div>
          </div>
        </div>
        <div className="main-frame">
          <div className="container">
            <div className="row justify-content-center">{children}</div>
          </div>
        </div>
      </div>
    </main>
  );
}
export const KeylessPageLayoutView = withRouter(KeylessView);

function KeylessEndPage() {
  const { localizationAssets } = useContext(DomainContext);
  const { t } = useTranslation();

  const [isLoadingVideo, setIsLoadingVideo] = useState(true);
  
  const handleExitClick = () => {
    window.location.href = "/convention";
  };

  return (
    <>
      <Loading active={isLoadingVideo} />
      <div
        onClick={handleExitClick}
        style={{
          position: "relative",
          height: "100dvh",
        }}
      >
        <VideoView
          src={localizationAssets["keylessEnd"]}
          style={{
            height: "100dvh",
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: "-1",
          }}
          hidden={isLoadingVideo}
          onLoaded={() => setIsLoadingVideo(false)}
          loop
        />
        <div
          style={{
            display: isLoadingVideo ? "none" : "flex",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            paddingBottom: "60px",
            gap: "1rem",
            zIndex: '2',
            position: 'relative'
          }}
        >
          <img
            style={{ width: "40%", margin: "7rem auto 5rem" }}
            src={localizationAssets["keylessGuerinLogo"]}
            alt="Guerin"
          />
          <h1
            style={{
              width: "85%",
              textAlign: "center",
              fontSize: "34px",
              color: "#f2f2f2bd",
              pointerEvents: "none",
            }}
          >
            {t("keylessFinalTitle")}
          </h1>
          <div style={{ flex: "1" }} />
          <div
            style={{
              width: "85%",
              textAlign: "center",
              fontSize: "24px",
              color: "#f2f2f2bd",
              pointerEvents: "none",
            }}
          >
            {t("keylessFinalMessage")}
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: "16px",
              color: "#f2f2f2bd",
              pointerEvents: "none",
            }}
          >
            {t("keylessFinalExit")}
          </div>
        </div>
      </div>
    </>
  );
}

function ConventionPageStyles({ children }) {
  return (
    <div
      style={{
        fontFamily: "'Bliss 2'",
      }}
    >
      {children}
    </div>
  );
}

function preloadVideos(videos) {
  videos.forEach((video) => {
    const videoElement = document.createElement("video");
    videoElement.src = video;
    videoElement.load();
  });
}

function preloadImgs(imgs) {
  imgs.forEach((img) => {
    const imgElement = new Image();
    imgElement.src = img;
  });
}
